// EnrollmentPaymentNotice — the payment line under an enrolled course card: a status badge and, when the
// student still has something to do, the link that expands the M-Pesa instructions. A paid enrollment
// shows nothing extra — the "Enrolled" badge already says it all.
import TransactionStatusBadge from "../shared/TransactionStatusBadge.js";
import type { EnrollmentPayment } from "@dm-lms/shared/types";

interface EnrollmentPaymentNoticeProps {
  payment:  EnrollmentPayment | null;   // null = no payment record for this enrollment
  expanded: boolean;
  onToggle: () => void;
}

function actionLabel(payment: EnrollmentPayment): string {
  if (payment.status === "failed") return "Resubmit code";
  return payment.reference !== null ? "View payment instructions" : "Complete payment";
}

export default function EnrollmentPaymentNotice({ payment, expanded, onToggle }: EnrollmentPaymentNoticeProps) {
  if (payment?.status === "success") return null;

  return (
    <div className="mt-2 flex flex-col items-start gap-1">
      <TransactionStatusBadge
        audience="card"
        status={payment?.status ?? null}
        hasReference={payment?.reference != null}
      />
      {payment === null && <p className="text-xs text-dm-slate">Contact support</p>}
      {payment !== null && payment.status !== "refunded" && (
        <button
          type="button"
          aria-expanded={expanded}
          onClick={onToggle}
          className="text-xs font-medium text-dm-royal underline-offset-2 hover:underline"
        >
          {expanded ? "Hide payment instructions" : actionLabel(payment)}
        </button>
      )}
    </div>
  );
}
